var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 14.6522C12.4102 15.513 12.7521 16.3386 13.3609 16.9474C13.9696 17.5561 14.7952 17.8981 15.6561 17.8981C16.5169 17.8981 17.3426 17.5561 17.9513 16.9474C18.56 16.3386 18.902 15.513 18.902 14.6522C18.902 13.7913 18.56 12.9657 17.9513 12.357C17.3426 11.7482 16.5169 11.4062 15.6561 11.4062C14.7952 11.4062 13.9696 11.7482 13.3609 12.357C12.7521 12.9657 12.4102 13.7913 12.4102 14.6522Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7765 20.7762L17.1857 25.367C16.7799 25.7723 16.2299 26 15.6563 26C15.0828 26 14.5327 25.7723 14.1269 25.367L9.53506 20.7762C8.32458 19.5656 7.50024 18.0233 7.16629 16.3443C6.83234 14.6652 7.00378 12.9249 7.65893 11.3432C8.31408 9.76164 9.42351 8.40982 10.8469 7.45873C12.2704 6.50764 13.9438 6 15.6558 6C17.3677 6 19.0412 6.50764 20.4646 7.45873C21.888 8.40982 22.9975 9.76164 23.6526 11.3432C24.3078 12.9249 24.4792 14.6652 24.1453 16.3443C23.8113 18.0233 22.987 19.5656 21.7765 20.7762Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsIcon);
export default __webpack_public_path__ + "static/media/tags-icon.f63a51e607bd1017b027abc2a7d6a994.svg";
export { ForwardRef as ReactComponent };